import { chartConfigurationsProps, configDataProps } from "processhub-components-lib/dist/lib/types/dashboard";

export const getDefaultConfigurations = (type: string): chartConfigurationsProps | configDataProps => {
  switch (type) {
    case 'large':
      return {
        k1: { id: '', name: '', value: '', type: '' },
        k2: { id: '', name: '', value: '', type: '' },
        k3: { id: '', name: '', value: '', type: '' },
      };
    case 'kpi':
      return {
        k1: { id: '', name: '', value: '', type: '' },
        k2: { id: '', name: '', value: '', type: '' },
        k3: { id: '', name: '', value: '', type: '' },
        k4: { id: '', name: '', value: '', type: '' },
      };
    case 'area':
      return { id: '', name: '', value: '', type: '' };
    case 'gauge':
    case 'gaugeBar':
      return {
        k1: { id: '', name: '', value: '' },
        k2: { id: '', name: '', value: '' },
        k3: { id: '', name: '', value: '' },
        k4: { id: '', name: '', value: '' },
      };
    case 'column':
      return {
        k1: { id: '', name: '', value: '' },
        k2: { id: '', name: '', value: '' },
        k3: { id: '', name: '', value: '' },
        k4: { id: '', name: '', value: '' },
      };
    case 'oneGaugeBar':
      return { k1: { id: '', name: '', value: '' } };
    default:
      // Explicitly return an empty object for the default case
      return { k1: { id: '', name: '', value: '' } };
  }
};

